import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Overlay from "../containers/general/overlay"
import { Redirect } from "react-router-dom"
import LoadingOverlay from "containers/general/loadingOverlay"
import { compose } from "redux"
import { getExecWeeklyPayload, loadingStatus } from "../actions"
import classNames from "classnames"
import Title from "containers/general/title"
import MobileMenuButton from "components/MobileMenuButton"
import _ from "lodash"
import settings from "settings"
import { Pie, HorizontalBar, Bar, Line } from "react-chartjs-2"
import colorArray from "helpers/colorArray"
import moment from "moment"
import ReactTable from "react-table"
import clone from "clone"
import timesFromPoint from "helpers/timesFromPoint"
import percentChange from "helpers/percentChange"
import yearlyTimes from "helpers/yearlyTimes"
import RenderOverride from "renderOverrides/RenderOverride"
import numeral from "numeral"
import helpers from "helpers/helpers"
import Chart from "react-apexcharts"

import "chartjs-plugin-datalabels"

import "chartjs-plugin-zoom"
let limit = 20
//! Island
class ExecutiveWeekly extends Component {
	constructor(props) {
		super(props)
		this.state = {
			name: "Company Wide",
			active: "all",
			nav: [{ id: "all", name: "Company Wide", icon: "far fa-arrows-h" }],
			endWeek: moment().startOf("isoweek").unix(),
			startWeek: moment.unix(moment().startOf("isoweek").unix()).subtract(7, "days").unix(),
			startYear: moment().startOf("year").unix(),
			sales: [],
			closings: [],
			bustouts: [],
			allSales: [],
			allBusts: [],
			weeklyTotals: {},
			propertyBreakout: {},
			times: timesFromPoint(0),
		}
		/* if (this.state.times.lastWeek == 0) {
			// We split week 53 and week 1 into two weeks for eoy reporting.  week 1 is internationally known as the week that contains jan 1, but we split it.  Commented out on 1/8/24 as it was messing up the island numbers.
			if (_.has(yearlyTimes, `${this.state.times.year - 1}.lastWeek.start`)) {
				this.state.times.year--
				this.state.times?.startWeek = yearlyTimes[this.state.times.year].lastWeek.start
				this.state.times?.endWeek = yearlyTimes[this.state.times.year].lastWeek.end
				this.state.startDayName = moment.unix(this.state.times.startWeek).format("dddd")
				this.state.endDayName = moment.unix(this.state.times.endWeek).format("dddd")
				this.state.times.year = this.state.times.year
				this.state.times.curWeek = 53
				this.state.times.curMonth = 12
			}
		} else if (this.state.times.lastWeek == 1) {
			if (_.has(yearlyTimes, `${this.state.times.year - 1}.firstWeek.start`)) {
				this.state.times.year--
				this.state.times?.startWeek = yearlyTimes[this.state.times.year].firstWeek.start
				this.state.times?.endWeek = yearlyTimes[this.state.times.year].firstWeek.end
				this.state.startDayName = moment.unix(this.state.times?.startWeek).format("dddd")
				this.state.endDayName = moment.unix(this.state.times?.endWeek).format("dddd")
			}
		} */
		if (_.get(settings, `execDeveloperSplit`)) {
			_.forEach(settings.execDeveloperSplit, (v) => {
				this.state.nav.push({
					id: `developer-${v.id}`,
					name: v.name,
					icon: "far fa-map",
				})
			})
		}

		this.sale_date = "sale_date"
		this.closing_date = "closing_date"
		this.bustout_date = "bustout_date"
		if (settings?.weekly?.useInputDate) {
			this.sale_date = "addedDate"
			this.closing_date = "closing_report_time"
			this.bustout_date = "bustout_report_time"
		}
	}

	componentDidMount() {
		let key = this.props.match.params.key
		this.props.getExecWeeklyPayload(key)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.payloadStatus !== this.props.payloadStatus) {
			let nav = clone(this.state.nav)
			_.forEach(this.props.payload.public.metro, (v) => {
				if (v.show == 0) {
					return
				}
				nav.push({
					id: v.id,
					name: v.name,
					icon: v.icon,
				})
			})
			let timeVar = timesFromPoint(this.props.payload.time)
			if (this.props.payload.week === 0) {
				let start = yearlyTimes[timeVar.reportYear].firstWeek.start
				let end = yearlyTimes[timeVar.reportYear].firstWeek.end
				timeVar.startDayName = moment.unix(start).format("dddd")
				timeVar.endDayName = moment.unix(end).format("dddd")
				timeVar.startWeek = moment().year(timeVar.reportYear).startOf("year").unix()
				timeVar.curWeek = 0
			} else if (timeVar.curWeek == 53) {
				// Since it's isoweek, it will always show 53, decide whether it's after 1/1 or before
				// We split week 53 and week 1 into two weeks for eoy reporting.  week 1 is internationally known as the week that contains jan 1, but we split it.
				let week = moment.unix(this.props.payload.time).week()
				let month = moment.unix(this.props.payload.time).month()
				if (month == 11) {
					if (_.has(yearlyTimes, `${timeVar.year - 1}.lastWeek.start`)) {
						console.log("%c" + `Loading Last Week`, "background: #222; color: #bada55")
						timeVar.year--
						timeVar.startWeek = yearlyTimes[timeVar.year].lastWeek.start
						timeVar.endWeek = yearlyTimes[timeVar.year].lastWeek.end
						timeVar.startDayName = moment.unix(timeVar.startWeek).format("dddd")
						timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
						timeVar.year = timeVar.year
						timeVar.curWeek = 53
						timeVar.curMonth = 12
					}
				} else {
					// Beginning of the new year
					if (_.has(yearlyTimes, `${timeVar.year}.firstWeek.start`)) {
						console.log("%c" + `Loading First Week`, "background: #222; color: #bada55")
						timeVar.startWeek = yearlyTimes[timeVar.year].firstWeek.start
						timeVar.endWeek = yearlyTimes[timeVar.year].firstWeek.end
						timeVar.startDayName = moment.unix(timeVar.startWeek).format("dddd")
						timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
						timeVar.curWeek = 1
						timeVar.curMonth = 1
					}
				}
			} else if (timeVar.curWeek == 52 && moment().year(timeVar.reportYear).isoWeeksInYear() == 52) {
				timeVar.endWeek = moment().year(timeVar.reportYear).endOf("year").endOf("day").unix()
				timeVar.endDayName = moment.unix(timeVar.endWeek).format("dddd")
			}
			this.setState({ nav: nav, times: timeVar }, () => {
				this.changeReport({ id: "all", name: "Company Wide" })
				//console.log(this.state)
			})
		}
	}

	developerSkip = (v, r) => {
		try {
			let active = r?.id
			if (!active) active = this.state.active
			if (active === `developer-null` && v.property_developer) {
				// regular developer jdc
				return true
			} else if (active !== "developer-null" && typeof active == "string" && active.includes("developer-")) {
				let split = active.split("-")
				if (split[1] !== v.property_developer) return true
			}
		} catch (e) {
			console.log(e)
		}
		return false
	}

	changeReport = (r) => {
		let sales = []
		let closings = []
		let bustouts = []
		let starts = []
		let traffic = []
		let traffic_grouped = []
		let allSales = []
		let allBusts = []
		let propertyBreakout = {}
		let propertyModel = {
			sales: [],
			bustouts: [],
			closings: [],
			starts: [],
			traffic: [],
			traffic_grouped: [],
		}
		_.forEach(this.props.payload.sales.allSales, (v) => {
			if (v[this.sale_date] < this.state.times?.startWeek || v[this.sale_date] > this.state.times?.endWeek) return
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].sales.push(v)

			sales.push(v)
		})
		_.forEach(this.props.payload.starts.current, (v) => {
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			starts.push(v)

			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].starts.push(v)
		})
		_.forEach(this.props.payload.traffic, (v) => {
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			traffic.push(v)

			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].traffic.push(v)
		})
		_.forEach(this.props.payload.traffic_grouped, (v) => {
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			traffic_grouped.push(v)

			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].traffic_grouped.push(v)
		})
		_.forEach(this.props.payload.sales.allSales, (v) => {
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			allSales.push(v)
		})
		_.forEach(this.props.payload.closings.allClosings, (v) => {
			if (v[this.closing_date] < this.state.times?.startWeek || v[this.closing_date] > this.state.times?.endWeek)
				return
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			closings.push(v)

			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].closings.push(v)
		})
		_.forEach(this.props.payload.bustouts.allBusts, (v) => {
			if (v[this.bustout_date] < this.state.times?.startWeek || v[this.bustout_date] > this.state.times?.endWeek)
				return
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			bustouts.push(v)

			if (!_.has(propertyBreakout, v.property)) {
				propertyBreakout[v.property] = _.cloneDeep(propertyModel)
			}
			propertyBreakout[v.property].bustouts.push(v)
		})
		_.forEach(this.props.payload.bustouts.allBusts, (v) => {
			if (this.developerSkip(v, r)) return
			if (typeof r.id === "number" && v.metro_group !== r.id) return
			allBusts.push(v)
		})
		let quick = this.quickStats(
			sales.length,
			bustouts.length,
			closings.length,
			starts.length,
			traffic.length,
			traffic_grouped,
			r.id
		)
		this.setState({
			active: r.id,
			sales: sales,
			bustouts: bustouts,
			closings: closings,
			name: r.name,
			weeklyTotals: quick,
			propertyBreakout,
			weeklyWebUsers: _.get(this.props.payload, `weeklyWebUsers.usersTotal`),
			weeklyWebSessions: _.get(this.props.payload, `weeklyWebUsers.sessions`),
			allSales,
			allBusts,
		})
	}

	renderNav() {
		let f = _.map(this.state.nav, (r, i) => {
			var here = r.id == this.state.active ? true : false
			var classes = classNames("body__navItem", {
				here: here,
			})
			return (
				<li
					key={i}
					className={classes}
					onClick={() => {
						this.changeReport(r)
					}}>
					<div className="body__navTitle">
						<i className={r.icon} />
						<span>{r.name}</span>
					</div>
				</li>
			)
		})
		return f
		//return ret
	}

	realtorPercent = () => {
		if (this.state.sales.length == 0) {
			return
		}
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.state.sales) {
			if (v.transfer_date || v.cancel_date) {
				continue
			}
			if (settings?.noRealtorTracking?.includes(v.property)) {
				continue
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	bustRate = () => {
		let percent = this.state.weeklyTotals.busts / this.state.weeklyTotals.gross
		if (!isFinite(percent)) {
			return 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdRealtorPercent = () => {
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.state.allSales) {
			if (settings?.noRealtorTracking?.includes(v.property)) {
				continue
			}
			let year = parseInt(moment.unix(v.sale_date).format("YYYY"))
			if (year !== this.state.times.endWeekYear) {
				continue
			}
			if (this.state.active !== "all") {
				if (v.metro_group !== this.state.active) {
					continue
				}
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)

		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Realtor Sales")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	ytdBustRate = () => {
		let sales = _.filter(this.state.allSales, (r) => {
			let year = parseInt(moment.unix(r.sale_date).format("YYYY"))
			if (year == this.state.times.endWeekYear && r.sale_date <= this.state.times.endWeek) {
				return true
			}
		})
		let busts = _.filter(this.state.allBusts, (r) => {
			let year = parseInt(moment.unix(r.bustout_date).format("YYYY"))
			if (year == this.state.times.endWeekYear && r.bustout_date <= this.state.times.endWeek) {
				return true
			}
		})
		let percent = busts.length / sales.length

		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	quickStats = (gross, busts, closings, starts, traffic, traffic_grouped, id) => {
		let net = gross - busts
		let tgrouped = 0
		_.forEach(traffic_grouped, (v) => {
			tgrouped += v.prospect_count
			tgrouped += v.realtor_count
		})
		let t = traffic + tgrouped

		return {
			gross,
			busts,
			closings,
			starts,
			traffic: t,
			net,
		}
	}

	lotTypes = () => {
		// First compile a list of all types
		let t = []
		for (let v of this.state.sales) {
			t.push(v.lot_type)
		}
		t = _.uniq(t)
		let types = {}
		for (let v of t) {
			let type = _.find(this.props.payload.public.lot_types, { id: v })
			if (type) {
				types[type.name] = 0
			}
		}

		for (let v of this.state.sales) {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			if (type) {
				types[type.name]++
			}
		}
		let d = []
		_.forEach(types, (v, k) => {
			d.push({ key: k, val: v })
		})
		d = _.sortBy(d, "val").reverse().slice(0, 12)

		const data = {
			labels: _.map(d, (r) => r.key),
			datasets: [
				{
					data: _.map(d, (r) => r.val),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	builderSales = () => {
		var [dataArray, labels, sorted, labelBuilders, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.builder) {
				return
			}
			if (v.builder in dataArray) {
				dataArray[v.builder]++
			} else {
				dataArray[v.builder] = 1
			}
		})
		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelBuilders.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelBuilders, (v) => {
			let b = _.find(this.props.payload.public.builders, {
				id: parseInt(v),
			})
			labels.push(`${b.name}`)
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}

		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)

		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	salesBySalespeople = () => {
		var [dataArray, labels, sorted, labelSalespeople, dataSorted] = [{}, [], [], [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.salesperson) {
				return
			}
			if (v.salesperson in dataArray) {
				dataArray[v.salesperson]++
			} else {
				dataArray[v.salesperson] = 1
			}
		})

		for (var prop in dataArray) {
			sorted.push([prop, dataArray[prop]])
		}
		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse()
		_.forEach(sorted, (v) => {
			labelSalespeople.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelSalespeople, (v) => {
			let sp = _.find(this.props.payload.public.salespeople, {
				id: parseInt(v),
			})
			if (sp) {
				labels.push(`${sp.first} ${sp.last}`)
			}
		})
		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales ",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		return <HorizontalBar data={data} options={opts} />
	}

	trafficSources = () => {
		// Need to count traffic and sale sources, traffic should come in the payload
		var [labels, dataArray, sorted, f] = [[], {}, [], []]
		_.forEach(this.state.sales, (v) => {
			if (!v.traffic_source) {
				return
			}
			if (v.traffic_source in dataArray) {
				dataArray[v.traffic_source]++
			} else {
				dataArray[v.traffic_source] = 1
			}
		})
		_.forEach(this.props.payload.traffic.split, (v, k) => {
			if (k in dataArray) {
				dataArray[k] += v
			} else {
				dataArray[k] = v
			}
		})
		for (var source in dataArray) {
			sorted.push([source, dataArray[source]])
		}
		sorted
			.sort(function (a, b) {
				return a[1] - b[1]
			})
			.reverse()
		_.forEach(sorted, (v) => {
			if (v[0] !== "0") {
				f.push(v[1])
				let b = _.find(this.props.payload.public.trafficSources, {
					id: parseInt(v),
				})
				labels.push(`${b.name}`)
			}
		})
		labels = labels.slice(0, limit)
		f = f.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sold",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: f,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	floorplans = () => {
		var [labels, floorplans, sorted, labelFloorplans, dataSorted] = [[], [], [], [], []]
		_.forEach(this.state.sales, (v, k) => {
			if (!v.floorplan) {
				return
			}
			//var floorplanName = this.props.payload.floorplans[v.floorplan]
			if (v.floorplan in floorplans) {
				floorplans[v.floorplan]++
			} else {
				floorplans[v.floorplan] = 1
			}
		})
		for (var prop in floorplans) {
			sorted.push([prop, floorplans[prop]])
		}

		sorted.sort(function (a, b) {
			return a[1] - b[1]
		})
		sorted = sorted.reverse().slice(0, limit)
		_.forEach(sorted, (v) => {
			labelFloorplans.push(v[0])
			dataSorted.push(v[1])
		})
		_.forEach(labelFloorplans, (v) => {
			v = parseInt(v)
			if (isNaN(v)) {
				return
			}
			let b = _.find(this.props.payload.public.floorplans, {
				id: parseInt(v),
			})
			if (b) {
				labels.push(`${b.name}`)
			}

			//labels.push(this.props.payload.public.floorplans[v])
		})
		labels = labels.slice(0, limit)
		dataSorted = dataSorted.slice(0, limit)
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: dataSorted,
				},
			],
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	salesMeter = () => {
		if (settings?.execSplitOutAnalysisBars) {
			let ret = []
			let sorted = _.sortBy(this.props.payload.communityPerformance, "name")
			_.forEach(sorted, (v, k) => {
				let current = v.thisYearSales - v.thisYearBusts
				let projected = v.current_projected
				let previous = v.net_previous_year
				let total = v.thisYearTotalProjected
				let currentPercent = (current / total) * 100
				let projectedPercent = (projected / total) * 100
				let previousPercent = (previous / total) * 100
				ret.push(
					<div className="my-10">
						<h3 className="statBox__title">{v.name}</h3>
						<div className="meter__cont">
							<div className="meter">
								<div className="meter__fill" style={{ width: currentPercent + "%" }}>
									<span>
										{current.toLocaleString()} Actual ({Math.round(currentPercent)}%)
									</span>
								</div>
								<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
									<span>
										{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
									</span>
								</div>
								<div
									className="meter__previous"
									style={{ left: previousPercent > 100 ? "100%" : previousPercent + "%" }}>
									<span>
										{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
									</span>
								</div>
							</div>
							<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
						</div>
					</div>
				)
			})
			return ret
		} else {
			let projected = 0
			let total = 0
			let current = 0
			let previous = 0
			_.forEach(this.props.payload.communityPerformance, (v, k) => {
				if (this.developerSkip(v)) return
				let active = this.state.active
				if (typeof active === "number" && v.metro_group !== active) return
				current += v.thisYearSales - v.thisYearBusts
				projected += v.current_projected
				previous += v.net_previous_year
				total += v.thisYearTotalProjected
			})
			let currentPercent = (current / total) * 100
			let projectedPercent = (projected / total) * 100
			let previousPercent = (previous / total) * 100
			return (
				<div>
					<h3 className="statBox__title">Home Sales Analysis YTD</h3>
					<div className="meter__cont">
						<div className="meter">
							<div className="meter__fill" style={{ width: currentPercent + "%" }}>
								<span>
									{current.toLocaleString()} Actual ({Math.round(currentPercent)}%)
								</span>
							</div>
							<div className="meter__projected" style={{ left: projectedPercent + "%" }}>
								<span>
									{projected.toLocaleString()} Projected ({Math.round(projectedPercent)}%)
								</span>
							</div>
							<div
								className="meter__previous"
								style={{ left: previousPercent > 100 ? "100%" : previousPercent + "%" }}>
								<span>
									{previous.toLocaleString()} Previous Year ({Math.round(previousPercent)}%)
								</span>
							</div>
						</div>
						<div className="meter__total">{total.toLocaleString()} Projected Annual Sales Goal</div>
					</div>
				</div>
			)
		}
	}

	cumulativeSales = () => {
		let year = this.state.times.endWeekYear
		let years = [year - 1, year]
		let ret = {
			[`${year} Net`]: [],
			[`${year - 1} Net`]: [],
			[`${year} Projected`]: [],
		}

		let labels = _.range(1, 53)
		_.forEach(years, (y) => {
			if (_.has(this.props.payload, `allSalesTotalsByWeek.${y}`)) {
				_.forEach(this.props.payload.allSalesTotalsByWeek[y], (r, k) => {
					try {
						let last = _.last(ret[[`${y} Net`]]) || 0
						let active = this.state.active
						if (typeof active === "string" && active.includes("developer-")) {
							let split = active.split("-")
							if (split[1] === "null") split[1] = "defaultDeveloper"
							ret[[`${y} Net`]].push(last + r.developers[split[1]].net)
						} else if (this.state.active == "all") {
							ret[[`${y} Net`]].push(last + r.net)
						} else {
							ret[[`${y} Net`]].push(last + r.metros[this.state.active].net)
						}
						if (year == y) {
							// current year for projections
							let last = _.last(ret[[`${y} Projected`]]) || 0
							if (typeof active === "string" && active.includes("developer-")) {
								let split = active.split("-")
								if (split[1] === "null") split[1] = "defaultDeveloper"
								ret[[`${y} Projected`]].push(r.developers[split[1]].projected + last)
							} else if (this.state.active == "all") {
								ret[[`${y} Projected`]].push(r.projected + last)
							} else {
								ret[[`${y} Projected`]].push(r.metros[this.state.active].projected + last)
							}
						}
					} catch (e) {
						console.log(e)
					}
				})
			}
		})

		// If viewing current year, chop off the weeks in the future.  Have -1 in there due to being 0 based, I think.
		if (year == moment().year()) {
			let currentWeek = moment().isoWeek()
			ret[`${year} Net`].length = currentWeek - 1
		}
		let opts = {
			tooltips: {
				enabled: false,
			},
			/* tooltips: {
				filter: function (tooltipItem) {
					// only show tooltips for net #s, not projections
					return tooltipItem.datasetIndex === 0 || tooltipItem.datasetIndex === 1
				}
			}, */
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
						},
					},
				],
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		const data = {
			labels: labels,
			datasets: [
				{
					label: [year + " Net"],
					data: ret[[year + " Net"]],
					borderColor: "#5A9BD4",
					backgroundColor: "#5A9BD4",
					fill: false,
				},
				{
					label: [year - 1 + " Net"],
					data: ret[[year - 1 + " Net"]],

					borderColor: "#F57A27",
					backgroundColor: "#F57A27",
					fill: false,
				},
			],
		}
		if (!settings.disabled.projections) {
			data.datasets.push({
				label: [year + " Projected"],
				data: ret[[year + " Projected"]],

				borderColor: "#000",
				backgroundColor: "#000",
				fill: false,
			})
		}
		//console.log(data)
		return <Line data={data} options={opts} />
	}

	inventoryStatus = () => {
		// First compile a list of all statuses
		let statuses = {
			"Pending Sale": 0,
			"Sales Opportunities": 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (this.state.active !== "all") {
				let prop = _.find(this.props.payload.public.properties, { id: v.property })
				if (prop && prop.metro_group !== this.state.active) {
					return
				}
			}
			if (v.closing_date) {
				return
			}
			if (v.sale_id) {
				// active sale - can use just sale_id because if it were closed it would have gotten caught before this
				statuses["Pending Sale"]++
			} else {
				statuses["Sales Opportunities"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Contract and Lot Status
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	salesOpportunities = () => {
		// First compile a list of all statuses
		let statuses = {
			"Specs Under Construction": 0,
			"Vacant Delivered": 0,
			"Vacant Pending": 0,
			"Completed Specs": 0,
			Models: 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.closing_date || v.sale_id || v.buyer_id) {
				return
			}
			if (this.developerSkip(v)) {
				return
			}
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			if (v.model === 1) {
				statuses["Models"]++
				count++
			} else if (v.start_date && !v.complete_date) {
				statuses["Specs Under Construction"]++
				count++
			} else if (v.complete_date && v.start_date) {
				statuses["Completed Specs"]++
				count++
			} else if (v.substantially_complete) {
				statuses["Vacant Delivered"]++
				count++
			} else if (!v.substantially_complete) {
				statuses["Vacant Pending"]++
				count++
			}
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<h3 className="statBox__title" style={{ marginBottom: "5px" }}>
					Sales Opportunity Breakdown
				</h3>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	builderVacantLots = () => {
		// First compile a list of all statuses
		let statuses = {
			"Builder Owned": 0,
			"Developer Owned - Delivered": 0,
			"Developer Owned - Pending": 0,
			"Developer Owned Unassigned to Builder": 0,
		}
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			if (v.start_date || v.complete_date || v.closing_date || v.sale_id || v.model == 1 || v.buyer_id) {
				return
			}
			if (v.takedown_date) {
				statuses["Builder Owned"]++
			} else if (v.builder && v.substantially_complete) {
				statuses["Developer Owned - Delivered"]++
			} else if (v.builder && !v.substantially_complete) {
				statuses["Developer Owned - Pending"]++
			} else if (!v.builder) {
				statuses["Developer Owned Unassigned to Builder"]++
			}
		})
		//
		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return <Pie data={data} options={opts} />
	}

	salesList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => {
					if (v.value) {
						return `$${v.value.toLocaleString()}`
					}
					return ""
				},
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.sales) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.price = r.price
			v.builder = builder
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	bustoutList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.bustouts) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	closingList = () => {
		let columns = [
			{
				Header: "Sales Person",
				accessor: "salesperson",
			},
			{
				Header: "Builder",
				accessor: "builder",
			},
			{
				Header: "Address",
				accessor: "address",
			},
			{
				Header: "Price",
				accessor: "price",
				Cell: (v) => `$${v.value.toLocaleString()}`,
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
			},
		]

		var ret = []

		for (let r of this.state.closings) {
			var v = {}
			let salesperson = ""
			if (r.salesperson) {
				let findsp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				if (findsp) {
					salesperson = `${findsp.first} ${findsp.last}`
				}
			}
			let builder = ""
			let findBuilder = _.find(this.props.payload.public.builders, { id: r.builder })
			if (findBuilder) {
				builder = findBuilder.name
			}

			v.salesperson = salesperson
			v.address = r.address
			v.builder = builder
			v.price = r.price
			v.date = r.sale_date ? r.sale_date : r.addedDate

			ret.push(v)
		}

		ret = _.sortBy(ret, "date").reverse()

		return <ReactTable loadingText="" data={ret} columns={columns} defaultPageSize={10} />
	}

	salesTD = () => {
		// Last 2 years
		let year = new Date().getFullYear()
		let years = [year - 1, year]
		let projection = 0
		let ret = {}
		// Only this year's projections
		_.forEach(this.props.payload.communityPerformance, (v, k) => {
			if (this.developerSkip(v)) return
			if (typeof this.state.active === "number" && v.metro_group !== this.state.active) return

			projection += v.current_projected
		})
		if (this.state.active !== "all") {
			let current = 0
			let projected = 0
			let previous = 0
			_.forEach(this.props.payload.communityPerformance, (v, k) => {
				if (this.developerSkip(v)) return
				if (typeof this.state.active === "number" && v.metro_group !== this.state.active) return

				current += v.thisYearSales - v.thisYearBusts
				projected += v.current_projected
				previous += v.net_previous_year
			})
			ret = {
				"Previous YTD": previous,
				"Actual YTD": current,
				"Projected YTD": projected,
			}
		} else {
			ret = {
				"Previous YTD": this.props.payload.ytdTotals.lastYearSales - this.props.payload.ytdTotals.lastYearBusts,
				"Actual YTD": this.props.payload.ytdTotals.thisYearSales - this.props.payload.ytdTotals.thisYearBusts,
				"Projected YTD": projection,
			}
		}
		let percents = {
			avp: Math.round(percentChange(ret["Projected YTD"], ret["Actual YTD"])), // actual vs projected
			pvc: Math.round(percentChange(ret["Previous YTD"], ret["Actual YTD"])), // previous vs current
		}
		_.forEach(percents, (v, k) => {
			if (Math.sign(v) == 1) {
				percents[k] = <span className="darkGreen bold">{`+${v}%`}</span>
			} else if (Math.sign(v) == -1) {
				percents[k] = <span className="red bold">{`${v}%`}</span>
			}
		})
		let sorted = []
		let labels = []
		_.forEach(ret, (v, k) => {
			labels.push(k)
			sorted.push(v)
		})
		if (settings.disabled.projections) {
			// Remove projections
			labels.pop()
			sorted.pop()
		}

		const opts = {
			layout: {
				padding: {
					right: 50,
				},
			},
			plugins: {
				datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
							userCallback: function (label) {
								if (Math.floor(label) === label) {
									return label
								}
							},
						},
					},
				],
			},
		}

		const data = {
			labels: labels,
			datasets: [
				{
					label: "NET Sales",
					backgroundColor: "#30576c",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: sorted,
				},
			],
		}
		return (
			<>
				<HorizontalBar data={data} options={opts} />
				<p style={{ textAlign: "center", fontSize: "14px" }}>
					Actual vs. Previous YTD: {percents.pvc}{" "}
					{!settings.disabled.projections && <>| Actual vs. Projected YTD: {percents.avp}</>}
				</p>
			</>
		)
	}

	communityPerformance = () => {
		let columns = [
			{
				Header: "Community",
				accessor: "community",
			},
			...(settings?.executiveReport?.communityPerformance?.showCounties
				? [{ Header: "County", accessor: "county" }]
				: []),
			{
				Header: "Weekly",
				columns: [
					{
						Header: "Gross Sales",
						accessor: "gross_sales",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.gross_sales
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net Sales",
						accessor: "net_sales",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.net_sales
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Cancellation Rate",
						accessor: "bust_rate",
						Cell: (v) => {
							/* if (v.value) {
								return `${v.value}%`
							} else if (v.value == 0) {
								return "0%"
							}
							return "" */
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return `${v.value}%`
								} else if (Math.sign(v.value) == -1) {
									return `-${v.value}%`
								}
							}
							return "0%"
						},
						Footer: (props) => {
							let percent = this.state.weeklyTotals.busts / this.state.weeklyTotals.gross
							percent = percent.toFixed(2)
							percent = parseFloat(percent)
							percent = Math.round(percent * 100)
							return percent + "%"
						},
					},
					{
						Header: "Closings",
						accessor: "closings",
						Footer: (props) => helpers.tableTotals(props, "closings", "0,0"),
					},
					{
						Header: "Specs",
						accessor: "specs",
						Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
					},
					{
						Header: "Traffic",
						accessor: "traffic",
						Footer: (props) => helpers.tableTotals(props, "traffic", "0,0"),
					},
					{
						Header: "Average Sale Price",
						accessor: "avg_price",
						Cell: (v) => {
							if (v.value) {
								return `$${v.value.toLocaleString()}`
							}
							return "N/A"
						},
					},
				],
			},
			{
				Header: "",
				className: "ReactTable__gutter",
				maxWidth: 10,
				sortable: false,
			},
			{
				Header: "Year to Date NET",
				columns: [
					{
						Header: "Previous Year",
						accessor: "previous_year",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.previous_year
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Projected YTD",
						accessor: "projected",
						show: settings.disabled.projections ? false : true,
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.projected
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net YTD",
						accessor: "actual",
						Footer: (props) => {
							let total = 0
							_.forEach(props.data, (v) => {
								total += v.actual
							})
							if (typeof total == "number") {
								return total.toLocaleString()
							}
							return total
						},
					},
					{
						Header: "Net/Projected Variance",
						accessor: "variance",
						show: settings.disabled.projections ? false : true,
						Cell: (v) => {
							if (v.value) {
								if (Math.sign(v.value) == 1) {
									return (
										<span className="darkGreen bold">
											+{v.value} / {v.original.avp}
										</span>
									)
								} else if (Math.sign(v.value) == -1) {
									return (
										<span className="red bold">
											{v.value} / {v.original.avp}
										</span>
									)
								}
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let actual = 0
							let projected = 0
							_.forEach(props.data, (v) => {
								if (v.actual) actual += v.actual
								if (v.projected) projected += v.projected
							})
							let total = actual - projected
							let percent = Math.round(percentChange(projected, actual))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
					{
						Header: "YoY Variance",
						accessor: "yoy_variance",
						Cell: (v) => {
							if (Math.sign(v.value) == 1) {
								return (
									<span className="darkGreen bold">
										+{v.value} / {v.original.pvc}
									</span>
								)
							} else if (Math.sign(v.value) == -1) {
								return (
									<span className="red bold">
										{v.value} / {v.original.pvc}
									</span>
								)
							}
							return "0 / 0%"
						},
						Footer: (props) => {
							let lastYear = 0
							let thisYear = 0
							_.forEach(props.data, (v) => {
								if (v.actual) thisYear += v.actual
								if (v.previous_year) lastYear += v.previous_year
							})
							let total = thisYear - lastYear
							let percent = Math.round(percentChange(lastYear, thisYear))
							if (Math.sign(total) == 1) {
								return (
									<span className="darkGreen bold">
										+{total} / +{percent}%
									</span>
								)
							} else if (Math.sign(total) == -1) {
								return (
									<span className="red bold">
										{total} / {percent}%
									</span>
								)
							} else {
								return 0
							}
						},
					},
				],
			},
		]

		var ret = []
		let count = 0
		_.forEach(this.props.payload.communityPerformance, (r, k) => {
			if (!r.property_active) return
			k = parseInt(k)
			if (this.developerSkip(r)) return
			let active = this.state.active
			if (typeof active === "number" && r.metro_group !== active) return
			let v = {}

			let property = _.find(this.props.payload.public.properties, { id: k })
			if (!property) {
				return
			}
			if (property && property.in_weekly_report === 0) {
				return
			}
			let county
			if(property.county) {
				let countyLookup = _.find(this.props.payload.public.counties, { id: property.county })
				if(countyLookup) {
					county = countyLookup.name
				}
			}
			v.community = property.name
			v.county = county
			v.gross_sales = r.weekly_gross
			v.net_sales = r.weekly_net
			v.bust_rate = r.weekly_bust_rate
			v.variance = r.variance
			v.closings = r.weekly_closings
			v.traffic = r.weekly_traffic
			v.specs = r.specs
			v.yoy_variance = r.yoy_variance
			v.previous_year = r.net_previous_year
			v.actual = r.net_current_actual
			v.projected = r.current_projected
			v.avg_price = r.avg_price
			v.avp = Math.round(percentChange(v.projected, v.actual))
			v.pvc = Math.round(percentChange(v.previous_year, v.actual))
			if (isNaN(v.avp) || !isFinite(v.avp)) {
				v.avp = 0
			}
			if (isNaN(v.pvc) || !isFinite(v.pvc)) {
				v.pvc = 0
			}
			if (Math.sign(v.avp) === 1) {
				v.avp = <span className="darkGreen bold">{`+${v.avp}%`}</span>
			} else if (Math.sign(v.avp) === -1) {
				v.avp = <span className="red bold">{`${v.avp}%`}</span>
			} else {
				v.avp = `0%`
			}

			if (Math.sign(v.pvc) === 1) {
				v.pvc = <span className="darkGreen bold">{`+${v.pvc}%`}</span>
			} else if (Math.sign(v.pvc) === -1) {
				v.pvc = <span className="red bold">{`${v.pvc}%`}</span>
			} else {
				v.pvc = `0%`
			}
			ret.push(v)
			count++
		})
		//ret = _.sortBy(ret, "date").reverse()
		return (
			<>
				<ReactTable
					data={ret}
					columns={columns}
					loadingText=""
					defaultPageSize={count}
					defaultSorted={[
						{
							id: "gross_sales",
							desc: true,
						},
						{
							id: "community",
							asc: true,
						},
					]}
				/>
			</>
		)
	}

	salesVariance = () => {
		let ret = {
			"Previous Year": [],
			"Net WTD": [],
			"Projected WTD": [],
		}

		let labels = []
		let sorted = _.sortBy(this.props.payload.communityPerformance, "name")
		_.forEach(sorted, (v, k) => {
			if (this.developerSkip(v)) return
			let active = this.state.active
			if (typeof active === "number" && v.metro_group !== active) return
			let property = _.find(this.props.payload.public.properties, { id: v.id })
			if (!property || property.in_weekly_report === 0) {
				return
			}
			labels.push(property.name)
			ret["Previous Year"].push(v.last_weekly_net)
			ret["Projected WTD"].push(v.weekly_projected)
			ret["Net WTD"].push(v.weekly_net)
		})
		let opts = {
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							beginAtZero: true,
						},
					},
				],
			},
		}

		const data = {
			labels: labels,
			datasets: [
				{
					label: "Previous Year Week " + this.state.times.curWeek,
					backgroundColor: "#C297F5",
					type: "line",
					fill: false,
					pointRadius: 10,
					pointHoverRadius: 10,
					borderColor: "#8f6fb5",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Previous Year"],
				},
				{
					label: "Net Week " + this.state.times.curWeek,
					backgroundColor: "#ace07e",
					borderColor: "#ace07e",
					borderWidth: 1,
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: ret["Net WTD"],
				},
			],
		}
		if (!settings.disabled.projections) {
			data.datasets.push({
				label: "Projected Week " + this.state.times.curWeek,
				backgroundColor: "#3295EC",
				borderColor: "#3295EC",
				borderWidth: 1,
				hoverBackgroundColor: "rgba(50,149,236,0.5)",
				hoverBorderColor: "rgba(50,149,236,0.9)",
				data: ret["Projected WTD"],
			})
		}
		//
		return <Bar data={data} options={opts} />
	}

	outputCommunityPerformance = (pos) => {
		if (settings.execCommunityPerformanceUpTop && pos === "bottom") return null
		else if (!settings.execCommunityPerformanceUpTop && pos === "top") return null
		return (
			<div className="statBox__row">
				<div className="statBox__row">
					<div className="statBox__box">
						<h3 className="statBox__title">Community Performance</h3>
						{this.communityPerformance()}
					</div>
				</div>
			</div>
		)
	}

	outputSalesAnalysis = (pos) => {
		if (settings.execAnalysisBarUpTop && pos === "bottom") return null
		else if (!settings.execAnalysisBarUpTop && pos === "top") return null

		return (
			<>
				{!_.get(settings, `weekly.restrictSalesMeter`) ? (
					<div className="statBox__row">
						<div className="statBox__box">{this.salesMeter()}</div>
					</div>
				) : (
					""
				)}
			</>
		)
	}

	outputQuickStats = () => {
		if (settings?.execSplitOutStats) {
			// split stats out by property.  If false default to combinging everyones stats
			let ret = []
			if (!_.isEmpty(this.state.propertyBreakout)) {
				// Sort by property name first
				_.forEach(this.state.propertyBreakout, (v, k) => {
					let property = _.find(this.props.payload.public.properties, { id: parseInt(k) })
					v.property = property?.name
				})
				let sorted = _.sortBy(this.state.propertyBreakout, "property")
				_.forEach(sorted, (v, k) => {
					let stats = this.quickStats(
						v.sales.length,
						v.bustouts.length,
						v.closings.length,
						v.starts.length,
						v.traffic.length,
						v.traffic_grouped.length
					)
					ret.push(
						<div key={`quickstats-${v?.property}`}>
							<div className="quickStats py-5">
								<div className="mx-auto w-[90%]">
									<h2 className="text-white pt-0 border-b-0">{v?.property}</h2>
								</div>
								<ul className="quickStats__list">
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.gross}</div>
											<div className="quickStats__type">Gross Sales</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.net}</div>
											<div className="quickStats__type">Net Sales</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.busts}</div>
											<div className="quickStats__type">Cancellations</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.closings}</div>
											<div className="quickStats__type">Closings</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.starts}</div>
											<div className="quickStats__type">Starts</div>
										</div>
									</li>
									<li className="quickStats__item">
										<div>
											<div className="quickStats__stat">{stats.traffic}</div>
											<div className="quickStats__type">Traffic</div>
										</div>
									</li>
									{this.state.weeklyWebUsers && this.state.active === "all" ? (
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(this.state.weeklyWebUsers).format("0,0")}
												</div>
												<div className="quickStats__type">Web Users</div>
											</div>
										</li>
									) : null}
									{this.state.weeklyWebSessions && this.state.active === "all" ? (
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(this.state.weeklyWebSessions).format("0,0")}
												</div>
												<div className="quickStats__type">Sessions</div>
											</div>
										</li>
									) : null}
								</ul>
							</div>
						</div>
					)
				})
			}
			if (ret.length) return ret
		}
		return (
			<div className="quickStats">
				<ul className="quickStats__list">
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.gross}</div>
							<div className="quickStats__type">Gross Sales</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.net}</div>
							<div className="quickStats__type">Net Sales</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.busts}</div>
							<div className="quickStats__type">Cancellations</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.closings}</div>
							<div className="quickStats__type">Closings</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.starts}</div>
							<div className="quickStats__type">Starts</div>
						</div>
					</li>
					<li className="quickStats__item">
						<div>
							<div className="quickStats__stat">{this.state.weeklyTotals.traffic}</div>
							<div className="quickStats__type">Traffic</div>
						</div>
					</li>
					{this.state.weeklyWebUsers && this.state.active === "all" ? (
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{numeral(this.state.weeklyWebUsers).format("0,0")}
								</div>
								<div className="quickStats__type">Web Users</div>
							</div>
						</li>
					) : null}
					{this.state.weeklyWebSessions && this.state.active === "all" ? (
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{numeral(this.state.weeklyWebSessions).format("0,0")}
								</div>
								<div className="quickStats__type">Sessions</div>
							</div>
						</li>
					) : null}
				</ul>
			</div>
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (!this.props.payloadStatus) {
			return (
				<div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		} else {
			if (_.get(settings, `renderOverrides.executive`)) {
				return (
					<div className="globalCont c">
						<div className="top">
							<div className="top__logo">
								<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
								{/* <div onClick={this.toggleMobileMenu}>
									<MobileMenuButton />
								</div> */}
							</div>
						</div>
						<div className="body">
							<div className="body__nav">&nbsp;</div>
							<div className="body__stageCont">
								<div className="body__stage" id="stage">
									<div className="content">
										<RenderOverride name={`${settings.renderOverrides.executive}`} {...this} />
									</div>
								</div>
							</div>
						</div>
					</div>
				)
			}
			//console.log(this.state)
			return (
				<div className="globalCont c">
					<div className="top">
						<div className="top__logo">
							<img src={settings.logo} alt="Pipsy" className="top__logoImg" />
							{/* <div onClick={this.toggleMobileMenu}>
								<MobileMenuButton />
							</div> */}
						</div>
					</div>
					<div className="body">
						<div className="body__nav">
							<ul
								className={classNames("body__navList", {
									active: this.state.navOpen,
								})}>
								{this.renderNav()}
							</ul>
						</div>
						<div className="body__stageCont">
							<div className="body__stage" id="stage">
								<Title title={`${this.state.name}`} showDate={false} cutPadding={true} />
								<p className="content weekly__date">
									Week {this.state.times.curWeek} | {this.state.times.startDayName || "Monday"}{" "}
									{moment.unix(this.state.times.startWeek).format("MMMM D") + " "}-{" "}
									{this.state.times.endDayName || "Sunday"}{" "}
									{moment.unix(this.state.times.endWeek).format("MMMM D")}
								</p>
								<div className="content">{this.outputCommunityPerformance("top")}</div>
								{this.outputQuickStats()}
								<div className="content">{this.outputSalesAnalysis("top")}</div>
								<div className="statBox">
									<div className="statBox__row statBox__row--quad">
										<div className="statBox__box">
											<h3 className="statBox__title">
												Realtor Sales - Week {this.state.times.curWeek}
											</h3>
											{this.realtorPercent()}
										</div>
										<div className="statBox__box">
											<h3 className="statBox__title">
												Cancellation Rate - Week {this.state.times.curWeek}
											</h3>
											{this.bustRate()}
										</div>
										<div className="statBox__box">
											<h3 className="statBox__title">Realtor Sales - YTD</h3>
											{this.ytdRealtorPercent()}
										</div>
										<div className="statBox__box">
											<h3 className="statBox__title">Cancellation Rate - YTD</h3>
											{this.ytdBustRate()}
										</div>
									</div>
									<div className="statBox__row statBox__row--double">
										<div className="statBox__box">
											<h3 className="statBox__title">Net Sales To Date</h3>
											{this.salesTD()}
										</div>
									</div>
									<div className="statBox__row hideMobile">
										<div className="statBox__box">
											<h3 className="statBox__title">Sales Variance</h3>
											{this.salesVariance()}
										</div>
									</div>
									{this.outputCommunityPerformance("bottom")}
									{this.outputSalesAnalysis("bottom")}
									<div className="statBox__row hideMobile">
										<div className="statBox__box">
											<h3 className="statBox__title">Cumulative Sales Analysis</h3>
											{this.cumulativeSales()}
										</div>
									</div>
									<div className="statBox__row statBox__row--double hideMobile">
										{/* <div className="statBox__box">{this.inventoryStatus()}</div> */}
										<div className="statBox__box">{this.salesOpportunities()}</div>
										<div className="statBox__box">
											<h3 className="statBox__title">Vacant Lot Inventory</h3>
											{this.builderVacantLots()}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		loadingStatus: state.loadingStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getExecWeeklyPayload,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(ExecutiveWeekly)
